import { DataBean } from "../DataBean";

export class Company extends DataBean {
  public async getAccountingCompanyProperties(idCompany: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.orange.bean.admin.Company_getAccountingCompanyProperties_Number",
      [idCompany]
    );
  }

  public async getAccountantIDLevelConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantIDLevelConstants_Number",
      [arg]
    );
  }

  public async getAccountantReportTypeConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantReportTypeConstants_Number",
      [arg]
    );
  }

  public async getCompanyCatalog(idCompany: number): Promise<any> {
    return this.getCustomService(
      "OrangeBase",
      "java.util.List_getCompanyCatalog_Number",
      [idCompany]
    );
  }

  public async deleteCompany(idCompany: number): Promise<any> {
    return this.getCustomService(
      "OrangeBase",
      "void_deleteCompany_Number",
      [idCompany]
    );
  }

  public async updateCompany(bean: any): Promise<any> {
    return this.getCustomService(
      "OrangeBase",
      "com.orange.bean.admin.Company_updateCompany_com.orange.bean.admin.Company",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: 'com.orange.bean.admin.Company'
        }
      ]
    );
  }

}
